import { defineMessages } from 'react-intl';

export default defineMessages({
  AutoI: {
    id: 'AutoIAutoI',
    defaultMessage: 'Auto-i',
  },
});
